import React from 'react';

// Aapki saari photos ke imports (Aapne jaise set kiye hain wese hi rehne dein)
import p1 from './p1.jpeg';
import p2 from './p2.jpeg';
import p3 from './p3.jpeg';
import p4 from './p4.jpeg';
import p5 from './p5.jpeg';
import p6 from './p6.jpeg';

const Gallery = () => {
  
  // Naye Professional Titles ke sath array
  const eduCenters = [
     { title: "Administration Office", src: p5 },
    { title: "Uniform & Kit Distribution", src: p1 },
    { title: " Skill Training Batch", src: p2 },
    { title: "IT & Computer Lab", src: p3 },
    { title: "Student Orientation Program", src: p4 },
   
    { title: "Counseling & Reception Area", src: p6 },
  ];

  return (
    <section id="gallery" className="mb-5 pt-4">
      <style>
        {`
          .gallery-card {
            border-radius: 1.25rem;
            overflow: hidden;
            border: 1px solid #e2e8f0;
            background: #ffffff;
            transition: all 0.4s ease;
          }
          
          .gallery-card:hover {
            transform: translateY(-10px);
            box-shadow: 0 20px 40px rgba(15, 23, 42, 0.1);
            border-color: #bae6fd;
          }

          .img-zoom-wrapper {
            overflow: hidden;
            position: relative;
            background-color: #f8fafc;
          }

          .img-zoom-wrapper img {
            transition: transform 0.6s ease;
          }

          .gallery-card:hover .img-zoom-wrapper img {
            transform: scale(1.08);
          }

          .gallery-title-main {
            color: #1e293b;
            font-family: 'Poppins', sans-serif;
            font-weight: 800;
          }
        `}
      </style>

      {/* Section Header */}
      <div className="text-center mb-5">
        <span className="text-uppercase fw-bold mb-2 d-block" style={{ color: '#0284c7', fontSize: '0.85rem', letterSpacing: '2px' }}>
          Our Facilities
        </span>
        <h3 className="gallery-title-main fs-2 mb-3">Training & Educational Centers</h3>
        <p className="text-muted mx-auto" style={{ maxWidth: '650px', fontSize: '1.05rem' }}>
          Take a glimpse into our educational facilities where we provide quality learning and skill development sessions to our students.
        </p>
      </div>
      
      {/* 6 Image Grid */}
      <div className="row g-4">
        {eduCenters.map((item, index) => (
          <div key={index} className="col-md-6 col-lg-4">
            <div className="gallery-card h-100 shadow-sm d-flex flex-column">
              
              <div className="img-zoom-wrapper">
                <img 
                  src={item.src} 
                  alt={item.title} 
                  className="w-100"
                  style={{ height: '240px', objectFit: 'cover' }}
                />
              </div>

              <div className="card-body text-center p-4">
                <h6 className="mb-0 fw-bold" style={{ color: '#0f172a', letterSpacing: '0.5px', fontFamily: 'Poppins, sans-serif' }}>
                  {item.title}
                </h6>
                <hr className="my-3 opacity-25 mx-auto" style={{ width: '40px', borderTop: '3px solid #0284c7' }} />
                {/* <small className="text-muted text-uppercase fw-semibold" style={{ fontSize: '0.75rem', letterSpacing: '1px' }}>
                  Facility 0{index + 1}
                </small> */}
              </div>

            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Gallery;